var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import { Button, TextField } from '@mui/material';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { CREATE_SUPPORT_REQUEST_ACTIVITY_VALIDATION } from 'common/graphql/mutations/support-request/create-support-request-activity-validation';
import { SUPPORT_REQUEST_RELATED_ACTIVITY_VALIDATIONS } from 'common/graphql/queries/support-request/support-request-related-activity-validations';
import useDynamicMutation from 'common/hooks/useDynamicMutation';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/actions';
var AddActivityValidationToSupportRequestDialog = function (_a) {
    var supportRequestId = _a.supportRequestId, handleClose = _a.handleClose;
    var _b = useState(''), activityValidationId = _b[0], setActivityValidationId = _b[1];
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var createSupportRequestActivityValidation = function (data) {
        return useMutation(CREATE_SUPPORT_REQUEST_ACTIVITY_VALIDATION, {
            variables: {
                createSupportRequestActivityValidationData: __assign({}, data)
            },
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: SUPPORT_REQUEST_RELATED_ACTIVITY_VALIDATIONS,
                    variables: {
                        id: supportRequestId
                    }
                },
            ]
        });
    };
    var onSuccess = function () {
        dispatch(openSnackbar({
            message: t("\u0414\u0430\u043D\u043D\u044B\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u044B"),
            severity: SnackbarSeverity.SUCCESS
        }));
        handleClose();
    };
    var onError = function (_a) {
        var code = _a.code;
        dispatch(openSnackbar({
            message: code,
            severity: SnackbarSeverity.ERROR
        }));
    };
    var handleExecuteMutation = useDynamicMutation(createSupportRequestActivityValidation, onSuccess, onError).handleExecuteMutation;
    var handleConfirm = function () {
        handleExecuteMutation({
            supportRequestId: supportRequestId,
            activityValidationId: activityValidationId
        });
    };
    return (_jsxs("div", __assign({ className: "flex flex-col space-y-20 items-center w-full justify-center" }, { children: [_jsx("div", __assign({ className: "tw-dialog-header" }, { children: t('Добавить валидацию тренировки к обращению') }), void 0), _jsx(TextField, { label: t('Введите ID валидации'), value: activityValidationId, onChange: function (e) {
                    setActivityValidationId(e.target.value);
                } }, void 0), _jsx(Button, __assign({ onClick: handleConfirm, disabled: activityValidationId === '' }, { children: t('Добавить') }), void 0)] }), void 0));
};
export default AddActivityValidationToSupportRequestDialog;
